import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./header1.css";
import { FaUser } from "react-icons/fa";
import entryIcon from "../../elements/enter (1).png";
import chatIcon from "../../elements/chat.png";
import logo from "../../elements/agivant.png";
import { isAuthenticated } from '../../services/studentportalapis';
import { logout } from '../../services/studentportalapis';
import { LuLayoutDashboard } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { resetLoggedInState } from "../../features/login/loginSlice";

const Header = () => {
  const loginInfo = useSelector((store) => store.loggedInState);
  const dispatch = useDispatch();
  const [isLoggedIn, setIsLoggedIn] = useState(false); // State to track authentication
  const [studentName, setStudentName] = useState(""); // State to hold the student's name
  const location = useLocation();
  const navigate = useNavigate();

  const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};


  useEffect(() => {
    const checkAuthentication = async () => {
      const loggedInStatus = await isAuthenticated(); // Call the async function
      setIsLoggedIn(loggedInStatus); // Update the state
    };

    // Check authentication status on component mount
    checkAuthentication(); 

    // Fetch and set student name from localStorage if logged in
    const storedStudentData = localStorage.getItem('student-details');
    if (storedStudentData) {
      const studentData = JSON.parse(storedStudentData);
      if (studentData.firstName && studentData.lastName) {
        // setStudentName(`${studentData.firstName} ${studentData.lastName}`);

        const formattedName = `${capitalizeFirstLetter(studentData.firstName)} ${capitalizeFirstLetter(studentData.lastName)}`;
        setStudentName(formattedName);
      }
    }
    const logoutListener = () => handleLogout();
    window.addEventListener("force-logout", logoutListener);
    return () => window.removeEventListener("force-logout", logoutListener);
  }, []); // Empty dependency array to run once on mount

  const isNotDashboard = location.pathname !== "/dashboard";
  

  const handleLogout = async () => {
    const response = await logout();
    if (response.success) {
        dispatch(resetLoggedInState());
        console.log('Logout successful');
        localStorage.removeItem('student-details');
        // Redirect to login page or reset application state
        navigate('/login');
    } else {
        console.error(response.error);
    }
};

  // Function to render profile or login icons based on authentication status
  const renderAuthLinks = () => {
    if (loginInfo.loggedInState) {
      return (
        <>
          {location.pathname !== '/userAcc' && (
            <Link to="/userAcc" className="header-link">
              <FaUser />
              <span>{studentName}</span>
            </Link>
          )}
          {location.pathname === '/userAcc' && (
            <a
              onClick={handleLogout} 
              className="text-red-500 bg-transparent border-none text-xl font-semibold cursor-pointer"
            >
              <span>Logout</span>
            </a>
          )}
        </>
      );
    } else if (location.pathname !== '/login'){
      return (
        <Link to="/login" className="header-link">
          <img src={entryIcon} alt="Login Icon" className="icon" />
          <span>Login</span>
        </Link>
      );
    }
  };

  const renderDashboardIcon = () => {
    if (loginInfo.loggedInState && isNotDashboard) {
      return (
        <Link to="/dashboard" className="header-link" title="Dashboard">
          <LuLayoutDashboard />
        </Link>
      );
    }
    return null; 
  };

  return (
    <header className="header flex">
      <div className="header-logo">
        <a href="https://www.agivant.com/"> <img src={logo} alt="Company Logo" className="logo" /></a>
      </div>
      <div className="header-links">
      {renderDashboardIcon()}
        {renderAuthLinks()} {/* Call the function to render auth links */}
        
        {location.pathname !== '/faq' && location.pathname !== '/userAcc' && (
          <Link to="/faq" className="header-link">
            <img src={chatIcon} alt="FAQ Icon" className="icon" />
            <span>FAQs</span>
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;
